export const BLOCK_TYPE = {
  ABOUT: 'physical_notes_details',
  PHYSICAL: 'physical_notes',
  FAQS: 'faqs'
};

export const BlockTypeToLabel = {
  [BLOCK_TYPE.ABOUT]: 'About',
  [BLOCK_TYPE.PHYSICAL]: 'Physical Notes',
  [BLOCK_TYPE.FAQS]: 'FAQs'
};

export const TAB_TYPE_TO_BLOCK_TYPE = {
  about: BLOCK_TYPE.ABOUT,
  physical_notes_details: BLOCK_TYPE.ABOUT,
  physical_notes: BLOCK_TYPE.PHYSICAL,
  faq: BLOCK_TYPE.FAQS
};

export const isAboutBlockType = (blockType) => blockType === BLOCK_TYPE.ABOUT;

export const DEFAULT_TABS = [
  { type: 'about', title: BlockTypeToLabel[BLOCK_TYPE.ABOUT] },
  { type: 'physical_notes', title: BlockTypeToLabel[BLOCK_TYPE.PHYSICAL] },
  { type: 'faq', title: BlockTypeToLabel[BLOCK_TYPE.FAQS] }
];

export const SCROLL_OFFSET_TOP = 140;

export const PHYSICAL_NOTES_CONTENT_TYPE_ID = '400';

export const DELIVERY_STATUS = {
  ADD_ADDRESS: 1,
  TRACK_ORDER: 2,
  VIEW_ORDER_DETAILS: 3
};

export const BUNDLE_BUNDLE_VIEWED = 'Bundle - Bundle Viewed';
export const BUNDLE_SEE_ALL_CLICKED = 'Bundle - See All Clicked';

export const modalHeadings = {
  numberOfBooks: 'No. of books',
  subjects: 'Subjects',
  authors: 'Authors',
  languages: 'Language',
  isbn13: 'ISBN-13',
  yearOfPublication: 'Year of publication'
};
